module.exports = __webpack_public_path__ + "img/steam-all-the-way.726d7b42.png";